/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SkillAcquisitionGoalModel } from '../../models/skill-acquisition-goal-model';

export interface GetPatientSkillAcquisitionGoals$Params {
  patientID?: number;
}

export function GetPatientSkillAcquisitionGoals(http: HttpClient, rootUrl: string, params?: GetPatientSkillAcquisitionGoals$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SkillAcquisitionGoalModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientSkillAcquisitionGoals.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SkillAcquisitionGoalModel>>;
    })
  );
}

GetPatientSkillAcquisitionGoals.PATH = '/api/Supervisor/GetPatientSkillAcquisitionGoals';
